import React from 'react'
import PropTypes from 'prop-types'
import { titleToId } from '../../utils'
import './table-of-contents.scss'

export default class TableOfConents extends React.Component {
  render() {
    const links = this.props.links.filter((link) => link);
    return (
      <div className="toc">
        <div className="toc__wrapper">
          {/* Don't change element's order here!! */}
          <input className="toc__checkbox" id="toc-toggle" type="checkbox" />
          <h2 className="toc__title">Contents</h2>
          <label className="toc__show" htmlFor="toc-toggle">[Show]</label>
          <label className="toc__hide" htmlFor="toc-toggle">[Hide]</label>
          <ul className="toc__list">
            {links.map((navElelemnt, index) => {
              const {title, link} = navElelemnt;
              if (typeof link === 'string') {
                return <li key={index}><a href={'#' + titleToId(link)}>{title}</a></li>
              } else if (Array.isArray(link)) {
                return (
                  <li key={index}>
                    <a href={'#' + titleToId(link[0].link)}>{title}</a>
                    <ul className="toc__list">
                      {link.map((nested, i) => <li key={i}><a href={'#' + titleToId(nested.link)}>{nested.title}</a></li>)}
                    </ul>
                  </li>
                )
              } else {
                return null
              }
            })}
          </ul>
        </div>
      </div>
    )
  }
}

TableOfConents.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)])
  )
}



// WEBPACK FOOTER //
// ./src/components/table-of-contents/table-of-contents.js